import { render, staticRenderFns } from "./SellerCustomers.vue?vue&type=template&id=066a8b5a"
import script from "./SellerCustomers.vue?vue&type=script&lang=js"
export * from "./SellerCustomers.vue?vue&type=script&lang=js"
import style0 from "./SellerCustomers.vue?vue&type=style&index=0&id=066a8b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports